import MainNavContainer from './Navigation/containers/MainNavContainer';
import MobileNavContainer from './Navigation/containers/MobileNavContainer';
import RightSideMenuContainer from './Navigation/containers/RightSideMenuContainer';
import VideoEditorModal from './Search/components/modal/VideoEditorModal/VideoEditorModal';
import BreadcrumbsContainer from './Search/containers/BreadcrumbsContainer';
import NavSearchContainer from './Search/containers/NavSearchContainer';
import TopNavigationWrapper from './TopNavigation/TopNavigationWrapper';

const NavApps = {
  'main-nav': MainNavContainer,
  'mobile-nav': MobileNavContainer,
  'unifiedNav-search-app': NavSearchContainer,
  'right-side-menu': RightSideMenuContainer,
  'bread-crumbs': BreadcrumbsContainer,
  'content-edit-modal': VideoEditorModal,
  'new-top-nav': TopNavigationWrapper,
};

export default NavApps;
